var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade"}},[_c('li',[_c('span',{staticClass:"shopName"},[_vm._v(_vm._s(_vm.restaurant.name))]),_vm._v(" "),_c('span',{staticClass:"removeButton",on:{"click":_vm.removeShop}},[_vm._v("x")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-767ab4f7","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/groups/shop.vue
// module id = null
// module chunks = 